/* eslint-disable no-dupe-class-members */
/* eslint-disable default-case */
import { Auth } from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';
import BaseComponent from 'foundation/base-component';
import { AmplifyClient } from 'project/amplify-client';
import Cookies from 'js-cookie';
import {
    USER_ID,
    LAST_VISIT_DATE,
    REFERRAL_CODE
} from '../../../general/js/user/constants';
import userService from '../../../general/js/user/user-service';
import Oauth from '../../sso/components/oauth';
import { isNullOrUndefined } from '../../../general/js/general-helpers';
import { getLastLogInData } from '../../sso/components/forms/helpers/form-helpers/sign-in-form-helpers';
import { getSSOSignInFormData, updateUserSignInDetails } from '../../sso/store/api/sign-in-form-api';
import { getFormattedUserSignInDetailsData } from '../../sso/store/actions/helpers/data-format-helper';
import {
    MembershipTypes, OauthQueryConstants, checkOauthFlow, setOauthSignOutReturnUrl
} from '../../../general/js/utils';
import { CookieNames } from '../../../general/js/utils/cookies';
import * as cookieHelper from '../../sso/helpers/cookie-helper';

export default class Account extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.userOrderHistoryCallbackUrl = this.options.userOrderHistoryCallbackUrl;
        this.ssoDomain = this.options.ssoDomain;

        this.init();
    }

    static getRequiredRefs() {
        return [
            'signInLink',
            'button',
            'name',
            'signOut'
        ];
    }

    init() {
        AmplifyClient.init();

        this.getUserStateCognito();

        // This method needed for trigger hide/show tooltip
        this.addListener(this.refs.button, 'click', this.onUserButtonClick);

        this.addListener(this.refs.signOut, 'click', this.onSignOut);
        this.addListener(this.refs.signInLink, 'click', this.onUserButtonClick);

        this.addListener(document, 'keydown', this.onkeydown);
        this.addListener(document, 'click', this.outerClickHandle);
        this.addListener(document, 'touchstart', this.outerClickHandle);
        this.addListener(document, 'tochDataChanged', this.tochDataChangedHandle);

        Oauth.handleOauthSignedOut({ allowReload: false, purgeValue: true, useDefaultRedirectUri: false });

        if (
            checkOauthFlow(OauthQueryConstants.COMPLETE_FORGOT_PASSWORD) ||
            checkOauthFlow(OauthQueryConstants.COMPLETE_REGISTER)
        ) {
            Oauth.handleOauthCompleteFlow();
        }

        Hub.listen('auth', ({ payload: { event } }) => {
            switch (event) {
                case 'signIn':
                    this.getUserStateCognito();
                    break;
                case 'tokenRefresh':
                    this.updateLastVisitInfo();
                    break;
                default:
                    break;
            }
        });
    }

    signInLinkShow() {
        this.refs.signInLink.classList.add('is-visible');
        this.element.classList.remove('is-signed-in');
    }

    accountinfoShow(user) {
        this.refs.name.forEach((name) => {
            name.innerHTML = user;
        });
        this.refs.button.classList.add('is-visible');
        this.element.classList.add('is-signed-in');

        this.refs.signInLink.classList.remove('is-visible');
    }

    getUserStateSecutix() {
        const cookieStx = Cookies.get(this.cookie);

        if (!cookieStx) {
            this.signInLinkShow();
            return;
        }

        const userData = JSON.parse(cookieStx);

        this.accountinfoShow(userData.firstName);
    }

    getUserStateCognito() {
        const bypassCache = userService.shouldCheckAuthUser();
        Auth.currentAuthenticatedUser({ bypassCache })
            .then((user) => {
                this.accountinfoShow(user.attributes.given_name);
                Oauth.handleOauthSignedIn({ allowReload: false, useDefaultRedirectUri: false });

                userService.setDataInLocalStorage(USER_ID, user.attributes.sub);
                cookieHelper.setCookiOnDomain(CookieNames.UserId, user.attributes.sub);

                if (bypassCache) {
                    userService.setCheckedUser();
                }

                const newMembershipList = user.attributes['custom:Membership'];
                const showOneClubHubLink = newMembershipList.split(';').includes(MembershipTypes.OneClub);
                const oldMembershipList = JSON.parse(userService.getDataFromLocalStorage(CookieNames.TOCH_USER_MEMBERSHIPS));

                if (newMembershipList !== oldMembershipList) {
                    userService.setTOCHUserMembershipsInLocalStorage(JSON.stringify(newMembershipList));
                    this.updateMyOneClubLink(showOneClubHubLink);
                }
            })
            .catch(() => {
                this.signInLinkShow();
            });
    }

    getUserOrderHistory() {
        return Auth.currentAuthenticatedUser()
            .then(() => {
                userService.loadUserOrderHistory(this.userOrderHistoryCallbackUrl, this.ssoDomain);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    onSignOut = (event) => {
        event.preventDefault();

        setOauthSignOutReturnUrl();

        userService.signOut();

        userService.removeDataFromLocalStorage(USER_ID);
        userService.removeDataFromLocalStorage(REFERRAL_CODE);

        cookieHelper.removeCookie(CookieNames.UserId);
    };

    onUserButtonClick = () => {
        if (!this.refs.tooltip) return;

        if (this.refs.tooltip.classList.contains('is-visible')) {
            this.refs.tooltip.classList.remove('is-visible');
        } else {
            this.refs.tooltip.classList.add('is-visible');
        }
    };

    onkeydown = (event) => {
        if (event.keyCode === 27) {
            if (!this.refs.tooltip) return;
            this.refs.tooltip.classList.remove('is-visible');
        }
    };

    outerClickHandle = (event) => {
        if (
            (this.refs.tooltip && !this.refs.tooltip.contains(event.target)) &&
            (this.refs.button && !this.refs.button.contains(event.target)) &&
            (this.refs.signInLink && !this.refs.signInLink.contains(event.target))
        ) {
            this.refs.tooltip.classList.remove('is-visible');
        }
    };

    tochDataChangedHandle = (event) => {
        this.updateMyOneClubLink(event.detail.showOneClubHubLink);
        userService.setTOCHUserMembershipsInLocalStorage(JSON.stringify(event.detail.membership));
    };

    updateMyOneClubLink(showOneClubHubLink) {
        const oneClubHeaderElement = document.getElementById('my-one-club-link');

        if (isNullOrUndefined(oneClubHeaderElement)) {
            return;
        }

        if (showOneClubHubLink) {
            oneClubHeaderElement.classList.remove('hidden');
        } else {
            oneClubHeaderElement.classList.add('hidden');
        }
    }

    needsToUpdateLastVisit() {
        const storedLastVisitDate = userService.getDataFromLocalStorage(LAST_VISIT_DATE);
        if (storedLastVisitDate) {
            const storedDate = new Date(storedLastVisitDate);
            const currentDate = new Date();

            if (storedDate.toDateString() === currentDate.toDateString()) {
                return false;
            }
        }

        return true;
    }

    updateLastVisitInfo() {
        const needsUpdate = this.needsToUpdateLastVisit();

        if (!needsUpdate) {
            return;
        }

        const { lastLoginDate, lastLoginPlatform, lastLoginDevice } = getLastLogInData();
        getSSOSignInFormData()
            .then((response) => {
                const { lastLoggedInDataCallBackUrl } = response.data;
                updateUserSignInDetails(
                    getFormattedUserSignInDetailsData(lastLoginDate, lastLoginDevice, lastLoginPlatform),
                    lastLoggedInDataCallBackUrl
                ).then((updateUserResponse) => {
                    if (updateUserResponse.hasErrors) return;
                    userService.setDataInLocalStorage(LAST_VISIT_DATE, lastLoginDate);
                })
                    .catch((updateUserError) => {
                        console.error(updateUserError);
                    });
            })
            .catch((error) => {
                console.error(error);
            });
    }
}
